var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2333_3031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7502 15.5002C11.5582 15.5002 11.3662 15.4267 11.2199 15.2804L5.21994 9.28044C4.92669 8.98719 4.92669 8.51319 5.21994 8.21994C5.51319 7.92669 5.98719 7.92669 6.28044 8.21994L11.7502 13.6897L17.2199 8.21994C17.5132 7.92669 17.9872 7.92669 18.2804 8.21994C18.5737 8.51319 18.5737 8.98719 18.2804 9.28044L12.2804 15.2804C12.1342 15.4267 11.9422 15.5002 11.7502 15.5002Z",
    fill: "#1D1D1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2333_3031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown24);
export default __webpack_public_path__ + "static/media/chevron-down-24.b310bbd44f7e28ab007f7bb372d9d071.svg";
export { ForwardRef as ReactComponent };